export default {"src":"/_next/static/media/blog_detail_dark_bg.4f85a859.svg","height":1585,"width":2733};